import { render, staticRenderFns } from "./EccxRecord.vue?vue&type=template&id=0d73be3b&scoped=true&"
import script from "./EccxRecord.vue?vue&type=script&lang=js&"
export * from "./EccxRecord.vue?vue&type=script&lang=js&"
import style0 from "./EccxRecord.vue?vue&type=style&index=0&id=0d73be3b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d73be3b",
  null
  
)

export default component.exports